import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Dashboard is deprecated - redirect to tree-builder
// All family tree functionality is now in /tree-builder
export default function Dashboard({ user }) {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the new tree-builder page
    navigate('/tree-builder', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent mb-4"></div>
        <p className="text-lg font-sans text-foreground-muted">Redirecting...</p>
      </div>
    </div>
  );
}
